import type { Component } from "../types/platform";
import { LAYER_RADII, posAtAngle } from "../hooks/useActiveNode";

export function ComponentNode({
  component,
  angle,
  isActive,
  isPinned,
  isConnected,
  onHover,
  onClick
}: {
  component: Component;
  angle: number;
  isActive: boolean;
  isPinned: boolean;
  isConnected: boolean;
  onHover: (component: Component) => void;
  onClick: (component: Component) => void;
}) {
  const p = posAtAngle(angle, LAYER_RADII.app);

  const bg = isActive
    ? "#fff"
    : isConnected
      ? "rgba(242,129,50,0.08)"
      : "rgba(255,255,255,0.06)";
  const borderStyle = isActive ? "solid" : "dashed";
  const borderColor = isActive
    ? "#F28132"
    : isConnected
      ? "rgba(242,129,50,0.75)"
      : "rgba(255,255,255,0.30)";
  const shadow = isActive
    ? "0 0 40px rgba(242,129,50,0.45)"
    : isConnected
      ? "0 0 24px rgba(242,129,50,0.32)"
      : "none";
  const labelColor = isActive
    ? "#F28132"
    : isConnected
      ? "#F28132"
      : "rgba(255,255,255,0.75)";

  return (
    <button
      type="button"
      aria-label={`Infrastructure: ${component.name}, ${component.tagline}`}
      aria-pressed={isPinned}
      title={component.tagline}
      onMouseEnter={() => onHover(component)}
      onFocus={() => onHover(component)}
      onClick={() => onClick(component)}
      className="absolute outline-none"
      style={{
        left: `${p.x}%`,
        top: `${p.y}%`,
        transform: "translate(-50%, -50%)"
      }}
    >
      <div
        className="flex flex-col items-center transition-transform duration-300"
        style={{ transform: isActive ? "scale(1.12)" : "scale(1)" }}
      >
        <div
          className="flex items-center justify-center rounded-full transition-all duration-300"
          style={{
            width: 64,
            height: 64,
            backgroundColor: bg,
            border: `1.5px ${borderStyle} ${borderColor}`,
            boxShadow: shadow,
            backdropFilter: "blur(8px)"
          }}
        >
          <div
            className="px-1 text-center text-[10px] tracking-tight transition-colors duration-300"
            style={{
              color: labelColor,
              fontWeight: 600,
              lineHeight: 1.1
            }}
          >
            {component.name}
          </div>
        </div>
      </div>
    </button>
  );
}
